import { render, staticRenderFns } from "./ReviewsCarouselCard.vue?vue&type=template&id=d54b6b28&"
import script from "./ReviewsCarouselCard.vue?vue&type=script&lang=js&"
export * from "./ReviewsCarouselCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCarouselCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports